import { render, staticRenderFns } from "./p1-at-field-summary.vue?vue&type=template&id=cfa01e02&scoped=true&"
import script from "./p1-at-field-summary.vue?vue&type=script&lang=js&"
export * from "./p1-at-field-summary.vue?vue&type=script&lang=js&"
import style0 from "./p1-at-field-summary.vue?vue&type=style&index=0&id=cfa01e02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa01e02",
  null
  
)

export default component.exports